module.exports = __webpack_public_path__ + "media/images/emblems/Staefa-blazon-cf1b7695397d0191b52ab03b7152c93e.svg";